// extracted by mini-css-extract-plugin
export default {"search":"searchBar_search__+4JfQ","icon":"searchBar_icon__VzmWH","input":"searchBar_input__pxNgE","clear":"searchBar_clear__6QMHY"};